// JsFromRoutes CacheKey ffe3c196f92ba60cd0f8903a81313ebb
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/deal_stages'),
}
